/**
 * Dynamic Select Components - Organized Exports
 *
 * This file now re-exports from the modular component structure.
 * Each component has been broken down into focused, maintainable pieces:
 *
 * - ClientSelectWithModal: Handles client selection with search and creation modal
 * - TicketSelectWithModal: Handles ticket selection with creation modal
 * - TemplateSelect: Simple template selection component
 * - useModalManager: Shared hook for modal state management
 *
 * Benefits:
 * - Single responsibility per component
 * - Easier testing and debugging
 * - Better code organization by job duty
 * - Reusable modal management logic
 */

// Deprecated alias removed. Use ClientSelectWithModal directly.
export { ClientSelectWithModal } from "./ClientSelectWithModal";
export { TicketSelectWithModal as TicketSelect } from "./TicketSelectWithModal";
export { TemplateSelect } from "./TemplateSelect";

// Export the shared utilities
export { useModalManager } from "./hooks/useModalManager";
export type { UseModalManagerProps, UseModalManagerReturn } from "./hooks/useModalManager";
